import { createContext as v, useContext as y } from "react";
import { a as m } from "../../../vanilla-CSAfDK5R.js";
import { b as u } from "../../../react-B_GApDuV.js";
const b = () => {
  const s = m(""), r = m(
    /* @__PURE__ */ new Map()
  );
  return {
    activeAtom: m(
      (o) => {
        const n = o(r), c = Array.from(n.keys());
        return o(s) || c[0];
      },
      (o, n, c) => {
        n(s, c);
      }
    ),
    idAtom: m(""),
    sizeAtom: m("md"),
    valuesAtom: r
  };
}, d = v(b()), V = () => {
  const s = y(d), { activeAtom: r, valuesAtom: o } = s, [n, c] = u(r), [i, x] = u(o);
  return {
    setActiveItem: (e) => {
      var A;
      if (typeof e == "number") {
        const a = Array.from(i.keys()), f = a.indexOf(n), p = Math.max(0, Math.min(f + e, i.size - 1));
        e = a[p];
      }
      c(e);
      const t = (A = i.get(e)) == null ? void 0 : A.current;
      t == null || t.focus(), t == null || t.click();
    },
    setItemValue: (e, t) => {
      i.get(e) !== t && x((A) => {
        const a = new Map(A);
        return a.set(e, t), a;
      });
    },
    ...s
  };
};
export {
  d as TabsContext,
  b as createTabsState,
  V as useTabsState
};
//# sourceMappingURL=index.js.map
